import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  AppBar,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Switch,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import DividerWithText from '../../DividerWithText/DividerWithText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import styles from '../constants/styles';
import {
  createNewEquipment,
  getEquipmentHoldingProfile,
} from '../../../redux/actions/equipmentsActions';
import { snackbarShowMessage } from '../../../redux/actions/snackbarActions';
import { getAllEntitiesCatalog as getCategories } from '../../../redux/actions/categoriesActions';
import VerticalTabsEquipmentAssigned from '../../EditEquipmentModal/VerticalTabsEquipmentAssigned';
import { ShowHoldingProfileEquipment } from '../../EditEquipmentModal/ShowHoldingProfileEquipment';
import { TabPanel } from '../../ProfilesTabs/TabPanel';

import {
  EquipmentAvailabilitySelector,
  ParseRequestAvailabilities as ParseAvailabilityPayload,
} from './../../EditEquipmentModal/EquipmentAvailabilitySelector';
import {
  EquipmentFranchiseGroupsSelector,
  ParseRequestAvailabilities as ParseFranchiseGroupsAvailabilityPayload,
} from './../../EditEquipmentModal/EquipmentFranchiseGroupsSelector';
import RBIAutocompleteSearch from '../../RBIAutocompleteSearch/RBIAutocompleteSearch';
import { useTranslation } from 'react-i18next';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {
  fr,
  enUS,
  ar,
  cs,
  da,
  de,
  es,
  zhCN,
  nl,
  id,
  it,
  ja,
  ko,
  pt,
  ru,
  sv,
  th,
  tr,
  zhTW,
  fi,
} from 'date-fns/locale';
import { parseISO } from 'date-fns';
import { formatYYYYMMDD } from '../../../utils/utils';
import moment from 'moment';
import {
  getWarrantyInformation,
  isPurchaseDateBeforeExpiryDate,
} from '../../RestaurantDetailsTabs/EquipmentTabRestaurant/helpers/equipmentWarranty';

export const localesMap = {
  frc: fr,
  fre: fr,
  eng: enUS,
  ara: ar,
  cze: cs,
  dan: da,
  ger: de,
  spa: es,
  spl: es,
  chs: zhCN,
  dut: nl,
  ind: id,
  fil: fi,
  ita: it,
  jpn: ja,
  kor: ko,
  ptb: pt,
  rus: ru,
  swe: sv,
  tai: th,
  tur: tr,
  cht: zhTW,
};

const CreateModel = ({ handleClose, handleRefreshOnCreate }) => {
  const classes = styles();
  const dispatch: any = useDispatch();
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  const approvalTypes = useSelector(
    (state: RootStateOrAny) => state.ApprovalTypesReducer.entities,
  );
  const categories = useSelector(
    (state: RootStateOrAny) => state.CategoriesReducer.entitiesCatalog,
  );
  const manufacturers = useSelector(
    (state: RootStateOrAny) => state.ManufacturersReducer.entitiesCatalog,
  );
  const cProfiles = useSelector(
    (state: RootStateOrAny) => state.CalibrationProfilesReducer.entities,
  );
  const selectedLanguage = localStorage.getItem('selectedLanguage') || 'eng';

  // Fetch categories without supplier when component mounts or brand changes
  useEffect(() => {
    if (selectedBrand) {
      dispatch(
        getCategories(
          {
            brand: selectedBrand,
            paginated: 1,
            status: 1,
            limit: 100,
          },
          {
            _disableRequestStatus: true,
          },
        ),
      );
    }
  }, [selectedBrand, dispatch]);

  const [searchObjectPrev, setSearchObjectPrev] = useState<any>({
    availability: '',
    category: '',
    supplier: '',
    description: '',
    model: '',
    manufacturer: '',
    profiles: [],
    is_core: false,
    requires_training: false,
    is_visible_for_franchise: false,
    is_active: false,
    type: '',
    equipment_serial_number: '',
    equipment_date_of_purchase: null,
    equipment_expiry_term: '',
    equipment_date_of_expiry: null,
    equipment_expiry_term_year: null,
    equipment_expiry_term_month: null,
    equipment_expiry_term_day: null,
  });

  const [tabValue, setTabValue] = React.useState(0);

  const handleChangeExpiryDate = date => {
    const warrantyInformation = getWarrantyInformation({
      dateOfPurchase: searchObjectPrev['equipment_date_of_purchase'],
      dateOfExpiry: date ? parseISO(moment(date).format(formatYYYYMMDD)) : null,
      expiryTermYear: searchObjectPrev['equipment_expiry_term_year'],
      expiryTermMonth: searchObjectPrev['equipment_expiry_term_month'],
      expiryTermDay: searchObjectPrev['equipment_expiry_term_day'],
      expiryTerm: searchObjectPrev['equipment_expiry_term'],
    });

    setSearchObjectPrev({
      ...searchObjectPrev,
      ...warrantyInformation,
    });
  };

  const handleChangeDateOfPurchase = date => {
    const warrantyInformation = getWarrantyInformation({
      dateOfPurchase: date
        ? parseISO(moment(date).format(formatYYYYMMDD))
        : null,
      dateOfExpiry: searchObjectPrev['equipment_date_of_expiry'],
      expiryTermYear: searchObjectPrev['equipment_expiry_term_year'],
      expiryTermMonth: searchObjectPrev['equipment_expiry_term_month'],
      expiryTermDay: searchObjectPrev['equipment_expiry_term_day'],
      expiryTerm: searchObjectPrev['equipment_expiry_term'],
    });

    setSearchObjectPrev({
      ...searchObjectPrev,
      ...warrantyInformation,
    });
  };

  const onSelectOption = (name: string, value = {}) => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      [name]: value,
    });
  };
  const [timer, setTimer] = useState<any>(null);

  const handleChangeTextfield = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    let warrantyInformation = {};
    if (
      [
        'equipment_expiry_term_year',
        'equipment_expiry_term_month',
        'equipment_expiry_term_day',
      ].includes(event.target.name)
    ) {
      const expiryTermYear =
        event.target.name === 'equipment_expiry_term_year'
          ? event.target.value
          : searchObjectPrev['equipment_expiry_term_year'];
      const expiryTermMonth =
        event.target.name === 'equipment_expiry_term_month'
          ? event.target.value
          : searchObjectPrev['equipment_expiry_term_month'];
      const expiryTermDay =
        event.target.name === 'equipment_expiry_term_day'
          ? event.target.value
          : searchObjectPrev['equipment_expiry_term_day'];
      warrantyInformation = getWarrantyInformation({
        dateOfPurchase: searchObjectPrev['equipment_date_of_purchase'],
        dateOfExpiry: null,
        expiryTermYear,
        expiryTermMonth,
        expiryTermDay,
        expiryTerm: searchObjectPrev['equipment_expiry_term'],
      });
    }
    setSearchObjectPrev({
      ...searchObjectPrev,
      [event.target.name]: event.target.value,
      ...warrantyInformation,
    });
  };

  const onTagsChange = (event, values) => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      profiles: values,
    });
  };

  const handleChangeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      [event.target.name]: event.target.checked,
    });
  };

  const handleChangeSwitchCalibration = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      calibration: event.target.checked,
      profiles: [],
    });
  };
  const holdingProfilesToAdd = useSelector(
    (state: RootStateOrAny) => state.EquipmentsReducer.equipmentHoldingProfiles,
  );
  const [profilesSelected, setProfilesSelected] = useState<any[]>([]);

  //#region Equipment Availability

  const [availabilityAllowance, setAvailabilityAllowance] = useState<any[]>([]);
  const [availabilityExclusions, setAvailabilityExclusions] = useState<any[]>(
    [],
  );
  const [availabilityFranchiseGroups, setAvailabilityFranchiseGroups] =
    useState<any[]>([]);

  const handleAvailabilityAllowanceChange = (value: any[]) => {
    setAvailabilityAllowance(value);
  };

  const handleAvailabilityExclusionsChange = (value: any[]) => {
    setAvailabilityExclusions(value);
  };

  const handleFranchiseGroupsChange = (value: any[]) => {
    setAvailabilityFranchiseGroups(value);
  };

  ////#endregion Equipment Availability
  /*
    useEffect(() => {
      dispatch(
        getEquipmentHoldingProfiles({
          brand: selectedBrand,
          page: 1,
          limit: 100,
          category: searchObjectPrev.category?.id || '',
          manufacturer_id: searchObjectPrev.manufacturer?.id || '',
        }),
      );

    }, [
      selectedBrand,
      searchObjectPrev.category,
      searchObjectPrev.manufacturer,
    ]);
    */
  const saveEquipment = async () => {
    const newEquipment = {
      brand_id: selectedBrand,
      category_id: searchObjectPrev['category'].id,
      approval_type_id: searchObjectPrev['type'],
      is_core: searchObjectPrev['is_core'],
      requires_training: searchObjectPrev['requires_training'],
      description: searchObjectPrev['description'],
      is_visible_for_franchise: searchObjectPrev['is_visible_for_franchise'],
      is_active: true,
      model: searchObjectPrev['model'],
      manufacturer_id: searchObjectPrev['manufacturer'].id,
      included_availability: ParseAvailabilityPayload(availabilityAllowance),
      ...(availabilityExclusions.length > 0 && {
        excluded_availability: ParseAvailabilityPayload(availabilityExclusions),
      }),
      ...(availabilityFranchiseGroups.length > 0 && {
        included_franchise_groups: ParseFranchiseGroupsAvailabilityPayload(
          availabilityFranchiseGroups,
        ),
      }),
      calibration_profile: searchObjectPrev['profiles'].map(p => p.id),
      holding_profiles_allocations: profilesSelected.map(profile => profile.id),
      equipment_serial_number: searchObjectPrev['equipment_serial_number'],
      equipment_date_of_purchase:
        searchObjectPrev['equipment_date_of_purchase'] || null,
      equipment_expiry_term: searchObjectPrev['equipment_expiry_term'],
      equipment_date_of_expiry:
        searchObjectPrev['equipment_date_of_expiry'] || null,
    };
    if (!searchObjectPrev['type']) delete newEquipment.approval_type_id;
    if (selectedBrand !== 'TH' || !searchObjectPrev['calibration'])
      delete newEquipment.calibration_profile;
    const response: any = await dispatch(
      createNewEquipment({
        ...newEquipment,
      }),
    );
    if (response?.status === 200) {
      dispatch(snackbarShowMessage('equipment.model.createSuccess'));
    }
    handleRefreshOnCreate();
    handleClose();
  };

  const [holdingProfilesSelected, setHoldingProfilesSelected] = useState([]);
  const onChangeMultiple = async (event, values) => {
    setHoldingProfilesSelected(values);
    const missingProfiles = values.filter(
      value =>
        !profilesSelected.find((profile: any) => profile.id === value.id),
    );
    const result: any = await Promise.all(
      missingProfiles.map(
        async profile =>
          await dispatch(getEquipmentHoldingProfile('', profile.id)),
      ),
    );
    setProfilesSelected([
      ...profilesSelected.map((p: any) => p),
      ...result.map((r: any) => r.data.holdingProfile),
    ]);
  };
  const handleRemove = (index, id) => () => {
    const newCopyProfiles = profilesSelected.filter((p, i) => i !== index);
    const newCopySelected = holdingProfilesSelected.filter(
      (p: any) => p.id !== id,
    );
    setProfilesSelected([...newCopyProfiles]);
    setHoldingProfilesSelected([...newCopySelected]);
  };

  const handleChangeSelect = event => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      [event.target.name]: event.target.value ? event.target.value : '',
    });
  };

  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <div className={classes.divItems}>
              <RBIAutocompleteSearch
                onChange={onSelectOption}
                value={searchObjectPrev['category']}
                id="category"
                label={t('createModel.category')}
                options={categories.filter(category => category.is_active)}
                width={'100%'}
              />
              <RBIAutocompleteSearch
                onChange={onSelectOption}
                value={searchObjectPrev['manufacturer']}
                id="manufacturer"
                label={t('createModel.manufacturer')}
                options={manufacturers.filter(
                  manufacturer => manufacturer.status,
                )}
                width={'100%'}
              />
            </div>
            <div className={classes.divItems}>
              <TextField
                style={{ width: '100%', marginTop: 8 }}
                size="small"
                onChange={handleChangeTextfield}
                value={searchObjectPrev['model']}
                name="model"
                variant="outlined"
                label={t('createModel.newModel')}
              />
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                style={{ marginTop: 8 }}
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  {t('createModel.approvalType')}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  name="type"
                  label={t('createModel.approvalType')}
                  fullWidth
                  onChange={handleChangeSelect}
                  value={searchObjectPrev['type']}
                >
                  {approvalTypes.map(type => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className={classes.divItems}>
              <TextField
                style={{ width: '100%', marginTop: 8 }}
                size="small"
                onChange={handleChangeTextfield}
                value={searchObjectPrev['equipment_serial_number']}
                name="equipment_serial_number"
                variant="outlined"
                label={t('createModel.SerialNumber')}
              />
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localesMap[selectedLanguage || 'eng']}
              >
                <DatePicker
                  style={{ width: '100%', margin: '8px 8px 8px 0px' }}
                  size="small"
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  id={`equipment_date_of_purchase`}
                  label={t('createModel.DateOfPurchase')}
                  format="yyyy-MM-dd"
                  clearable
                  disableFuture
                  name={`equipment_date_of_purchase`}
                  value={searchObjectPrev['equipment_date_of_purchase'] || null}
                  onChange={handleChangeDateOfPurchase}
                  error={
                    !isPurchaseDateBeforeExpiryDate(
                      searchObjectPrev['equipment_date_of_purchase'],
                      searchObjectPrev['equipment_date_of_expiry'],
                    )
                  }
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className={classes.divItems}>
              <Box component="fieldset">
                <FormLabel component="legend">
                  {t('createModel.ExpiryTerm')}
                </FormLabel>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                  <TextField
                    style={{ width: '100%' }}
                    size="small"
                    onChange={handleChangeTextfield}
                    value={searchObjectPrev['equipment_expiry_term_year']}
                    name="equipment_expiry_term_year"
                    variant="outlined"
                    label={t('createModel.Year')}
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    InputLabelProps={{
                      shrink:
                        searchObjectPrev['equipment_expiry_term_year'] !== null,
                    }}
                  />
                  <TextField
                    style={{ width: '100%' }}
                    size="small"
                    onChange={handleChangeTextfield}
                    value={searchObjectPrev['equipment_expiry_term_month']}
                    name="equipment_expiry_term_month"
                    variant="outlined"
                    label={t('createModel.Month')}
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    InputLabelProps={{
                      shrink:
                        searchObjectPrev['equipment_expiry_term_month'] !==
                        null,
                    }}
                  />
                  <TextField
                    style={{ width: '100%' }}
                    size="small"
                    onChange={handleChangeTextfield}
                    value={searchObjectPrev['equipment_expiry_term_day']}
                    name="equipment_expiry_term_day"
                    variant="outlined"
                    label={t('createModel.Day')}
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    InputLabelProps={{
                      shrink:
                        searchObjectPrev['equipment_expiry_term_day'] !== null,
                    }}
                  />
                </Box>
              </Box>
            </div>
            <div>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localesMap[selectedLanguage || 'eng']}
              >
                <DatePicker
                  style={{ width: '50%', margin: '8px 8px 8px 0px' }}
                  size="small"
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  id={`equipment_date_of_expiry`}
                  label={t('createModel.DateOfExpiry')}
                  format="yyyy-MM-dd"
                  clearable
                  name={`equipment_date_of_expiry`}
                  value={searchObjectPrev['equipment_date_of_expiry'] || null}
                  onChange={handleChangeExpiryDate}
                  error={
                    !isPurchaseDateBeforeExpiryDate(
                      searchObjectPrev['equipment_date_of_purchase'],
                      searchObjectPrev['equipment_date_of_expiry'],
                    )
                  }
                />
              </MuiPickersUtilsProvider>
            </div>
            <div>
              <TextField
                fullWidth
                size="small"
                style={{ marginTop: 15 }}
                variant="outlined"
                label={t('createModel.description')}
                onChange={handleChangeTextfield}
                value={searchObjectPrev['description']}
                name="description"
              />
            </div>
            <div>
              <FormControl component="fieldset">
                <FormGroup aria-label="position" row>
                  <FormControlLabel
                    value="start"
                    control={
                      <Switch
                        checked={searchObjectPrev['is_core']}
                        onChange={handleChangeSwitch}
                        name="is_core"
                        color="primary"
                      />
                    }
                    label={t('equipment.core')}
                    labelPlacement="start"
                  />
                  <FormControlLabel
                    value="start"
                    control={
                      <Switch
                        checked={searchObjectPrev['is_visible_for_franchise']}
                        onChange={handleChangeSwitch}
                        name="is_visible_for_franchise"
                        color="primary"
                      />
                    }
                    label={t('createModel.franchiseVisible')}
                    labelPlacement="start"
                  />
                  <FormControlLabel
                    value="start"
                    control={
                      <Switch
                        checked={searchObjectPrev['requires_training']}
                        onChange={handleChangeSwitch}
                        name="requires_training"
                        color="primary"
                      />
                    }
                    label={t('equipment.training')}
                    labelPlacement="start"
                  />
                  {selectedBrand === 'TH' && (
                    <FormControlLabel
                      value="start"
                      control={
                        <Switch
                          checked={searchObjectPrev['calibration']}
                          onChange={handleChangeSwitchCalibration}
                          name="calibration"
                          color="primary"
                        />
                      }
                      label={t('createModel.calibrationCheck')}
                      labelPlacement="start"
                    />
                  )}
                </FormGroup>
              </FormControl>
            </div>
            {searchObjectPrev['calibration'] && (
              <div>
                <Autocomplete
                  multiple
                  id="tags-outlined"
                  options={cProfiles}
                  onChange={onTagsChange}
                  getOptionLabel={(profile: any) => profile.name || ''}
                  filterSelectedOptions
                  noOptionsText={t`app.common.noOptions`}
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={t('equipment.editEquipment.calibrationProfiles')}
                      placeholder="Select Profiles"
                    />
                  )}
                />
              </div>
            )}
            <div style={{ marginTop: 15 }}>
              <EquipmentAvailabilitySelector
                allowance={availabilityAllowance}
                exclusions={availabilityExclusions}
                hasExclusions={true}
                onAllowanceChange={handleAvailabilityAllowanceChange}
                onExclusionsChange={handleAvailabilityExclusionsChange}
                spacing={0}
              />
            </div>
            <div style={{ marginTop: 15, marginBottom: 15 }}>
              <EquipmentFranchiseGroupsSelector
                id="franchise-groups-availability-input"
                label={t('createModel.franchiseGroups')}
                brand={selectedBrand}
                value={availabilityFranchiseGroups}
                onChange={handleFranchiseGroupsChange}
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <AppBar position="static" className={classes.appBar}>
              <Toolbar variant="dense">
                <Typography>
                  {t('createModel.descriptionTranslations')} (0)
                </Typography>
              </Toolbar>
            </AppBar>
            <Paper className={classes.paper}>
              <DividerWithText mt={10}>English</DividerWithText>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <AppBar position="static" className={classes.appBar}>
          <Toolbar variant="dense" className={classes.flexSpaceBetween}>
            <Typography>{t('createModel.holdingProfiles')}</Typography>
            <Autocomplete
              multiple
              style={{ minWidth: '350px' }}
              id="tags-outlined"
              options={holdingProfilesToAdd.holdingProfiles || []}
              value={holdingProfilesSelected}
              noOptionsText={t`app.common.noOptions`}
              filterSelectedOptions
              onChange={onChangeMultiple}
              getOptionLabel={(p: any) =>
                `(${p.category.name},${p.manufacturer.name})${p.availabilities[0]?.region}`
              }
              disabled
              // filterSelectedOptions
              size="small"
              renderInput={params => (
                <TextField
                  {...params}
                  variant="outlined"
                  label={t('equipment.addFromCatalog')}
                  placeholder={t('equipment.addFromCatalog')}
                  size="small"
                />
              )}
            />
          </Toolbar>
        </AppBar>
        <Paper className={`${classes.paper} ${classes.holdingProfilesTabs}`}>
          <VerticalTabsEquipmentAssigned
            profiles={profilesSelected}
            value={tabValue}
            setValue={setTabValue}
            defaultName={t('createModel.holdingProfiles')}
          />
          {profilesSelected.map((profile, index) => (
            <TabPanel value={tabValue} index={index}>
              <ShowHoldingProfileEquipment
                title="Product Profile Availability"
                holdingProfile={profile}
                handleRemove={handleRemove}
                index={index}
              />
            </TabPanel>
          ))}
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <div className={classes.divItems}>
          <div></div>
          <div className={classes.divFilters}>
            <Button variant="outlined" color="primary" onClick={handleClose}>
              {t('app.common.cancel')}
            </Button>
            <Button
              disabled={
                !searchObjectPrev['category'] ||
                !searchObjectPrev['manufacturer'] ||
                !searchObjectPrev['description'] ||
                !searchObjectPrev['model'] ||
                !searchObjectPrev['type'] ||
                availabilityAllowance.length === 0 ||
                (selectedBrand === 'TH' &&
                  searchObjectPrev['calibration'] &&
                  !searchObjectPrev['profiles'].length)
              }
              variant="contained"
              color="primary"
              onClick={saveEquipment}
            >
              {t('app.common.save')}
            </Button>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default CreateModel;
